import {LanguageMenuModuleTerms} from "./language-menu-module.terms";
import {BaseConfig} from "../../infrastructure/config/base-config";

export class LanguageMenuModuleConfig extends BaseConfig {

  static injectables = [LanguageMenuModuleTerms];

  constructor(terms: LanguageMenuModuleTerms){
    super('languageMenuModule', null, terms);
  }
}
